/**
 * 模块 - 展示卡片 - 中文
 */
export default {
  showCard: {
    // cardShow - 账号升级弹窗
    cardShow: '账号升级',
    dingTalkStep1: '请使用您上一步提交的手机号登录打开钉钉',
    dingTalkStep2: '系统已向您发送加入总部的团队邀请',
    dingTalkStep3: '同意该邀请后将完成账号的升级',
    agreedInvite: '已同意邀请？可试试',
    complete: '完成',
    mergeAccount: '合并账号',
    addAgentAccountTip: '请添加您的代理商账号',
    accountLabel: '账号：',
    pleaseEnterAccount: '请输入账号',
    passwordLabel: '密码：',
    pleaseEnterPassword: '请输入密码',
    addAccountBtn: '添加账号',
    back: '返回',
    upgradeSuccess: '账号升级成功',
    upgradeSuccessTip: '您可以从',
    upgradeSuccessTip2: '登录，体验升级后的功能。',
    loginWithNewAccount: '使用新账号登录',
    accountAlreadyAdded: '该账号已添加，请勿重复操作',
    pleaseEnterAccountPassword: '请输入账号密码',
    addSuccess: '添加成功',
    addFailed: '添加失败',
    refreshed: '已刷新',

    // upgradeDetails - 升降级详情
    upgradeDetails: '升降级详情',
    dealerParticipateTip: '经销商参与升降级考核，相关指标和规则解释说明，请参见：',
    assessmentDetail: '考核详情!',
    performanceShortfallKeep: '距保级业绩差',
    performanceShortfallUpgrade: '距升级业绩差',

    // advertiseMessage - 公告消息
    objectionSubmit: '异议提交',
    advertiseMessage: '公告消息',
    setEmergencyContact: '设置紧急联系人',
    viewDetail: '查看详情',
    downloadAttachment: '下载附件',
    objectionContent: '异议内容',
    viewObjectionContent: '查看异议内容',
    objectionContentLabel: '异议内容：',
    objectionPlaceholder: '请你填写您关于公告的内容',
    close: '关闭',
    noAttachment: '该公告下无附件',
    download: '下载',
    viewNoticeDetail: '查看公告详情',
    giveUpRights: '放弃权益',
    skip: '跳过 >',
    pleaseEnterPhoneForRecovery: '请输入账号手机号，可用于找回密码',
    pleaseEnterValidPhone: '请输入正确的手机号',
    pleaseEnterVerifyCode: '请输入验证码',
    verifyCodeFormatError: '验证码格式错误',
    pleaseEnterPhone: '请输入手机号',
    sendSuccess: '发送成功',
    requestFailed: '请求失败',
    operationFailed: '操作失败',
    closeButton: '关闭',
    closeWithCountdown: '关闭 ({n}s)',
    objectionContact: '如有异议，请联系我',
    objectionLengthTip: '请填写您10～100字内的异议内容',
    submitSuccess: '提交成功',
    submitFailed: '提交失败',

    // commodityRatioMsg - 商品配比
    commodityRatioMsg: '商品配比',
    autoOrderRatioTitle: '自动下单商品配比维护',
    agentId: '代理商ID：',
    ratioTip: '*请务必准确维护各型号配比，自动下单将根据此配比分配下单金额！所有型号配比合计必须等于100%。',
    modelName: '商品型号',
    ratio: '配比',
    ratioTotal: '合计',
    pleaseEnterRatio: '请输入配比',
    updateLog: '更新记录：',
    ratioValidationError: '请正确填写配比值：1到100的整数，且配比合计等于100%',
    saveSuccess: '保存成功',
    saveFailed: '保存失败',

    // AdvertiseMessage config
    noticeTitle: '公告标题',
    pleaseEnterNoticeTitle: '请输入公告标题',
    noticeType: '公告类型',
    pleaseSelectNoticeType: '请选择公告类型',
    urgencyLevel: '重要度',
    pleaseSelectUrgencyLevel: '请选择重要度',
    readStatus: '状态',
    pleaseSelectStatus: '请选择状态',
    sendTime: '发送时间',
    readTime: '已读时间',
    studentAccount: '学员账号',
    studentName: '学生姓名',
    campusId: '校区ID',
    campusName: '校区名称',
    performanceType: '业绩类型',
    q1Performance: '第一季度业绩',
    q2Performance: '截止第二季度业绩',
    q2Remark: '（含第一季度业绩）',
    q3Performance: '截止第三季度业绩',
    q3Remark: '（含第一,二季度业绩）',
    q4Performance: '截止第四季度业绩',
    q4Remark: '（含第一,二,三季度业绩）',
    upgradeGap: '距升级业绩差'
  }
}
